var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3953 7.18795C3.3953 6.04017 4.08333 5.60976 5.01068 5.05021C6.0726 4.40459 7 3.81636 7 2.53945C7 0.87518 5.29487 0 3.45513 0C2.19872 0 1.09188 0.34433 0 0.93257V2.41033C1.15171 1.69297 2.00427 1.23386 3.26068 1.23386C4.6218 1.23386 5.51923 1.82209 5.51923 2.63989C5.51923 3.27116 5.01068 3.61549 4.24786 4.14634C2.51282 5.35151 2.18376 5.83931 2.1688 7.48924H3.3953V7.18795ZM2.78205 10C3.20086 10 3.54487 9.6126 3.54487 9.1105C3.54487 8.637 3.23077 8.2353 2.78205 8.2353C2.34829 8.2353 2.01923 8.6083 2.01923 9.1392C2.01923 9.67 2.36325 10 2.78205 10Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.1f09de8c.svg";
export { ForwardRef as ReactComponent };